/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       AddImage.tsx
 * @author     Christian Ascone
 * @date       9/16/19 1:11 PM
 */

import React from 'react';
import {Image} from "react-native";

export function AddImage(props) {
    return (
        <Image
            {...props}
            style={[props.style]}
            source={
                require('../../assets/images/add.png')
            }
        />
    );
}